$(window).scroll(function() {
  if ($(this).scrollTop() > 300) {
    $('.stock-top').css('opacity', 0);
  } else {
    $('.stock-top').css('opacity', 1);
  }
});
// Function to calculate the length of each SVG path
const calculatePathLength = (path) => {
  const length = path.getTotalLength();
  path.style.strokeDasharray = length;
  path.style.strokeDashoffset = length;
};

// Animate SVG paths
const svgPaths = document.querySelectorAll("svg path");
svgPaths.forEach(path => {
  calculatePathLength(path);
  gsap.to(path, {
    strokeDashoffset: 0,
    duration: 4,
    ease: "power1.inOut",
    repeat: -1,
    yoyo: false
  });
});

// Animate each letter in the h3 element
const letters = document.querySelectorAll("#loading-text span");
letters.forEach((letter, index) => {
  gsap.to(letter, {
    opacity: 1,
    duration: 1,
    ease: "power1.inOut",
    delay: index * (1 / letters.length),
    repeat: -1,
    repeatDelay: 2
  });
});

// Select the div to observe
const loadingBg = document.querySelector('.loading_bg');

// Function to check for the specific class and stop animations
const checkForClassAndStopAnimations = () => {
  if (loadingBg.classList.contains('dopple_loaded')) {
    // Kill all GSAP animations for the SVG paths and letters
    gsap.killTweensOf(svgPaths);
    gsap.killTweensOf(letters);
  }
};

// Create a MutationObserver to watch for changes in the class attribute
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.attributeName === 'class') {
      checkForClassAndStopAnimations();
    }
  });
});

// Start observing the loadingBg div for attribute changes
//observer.observe(loadingBg, { attributes: true });

// Your existing code continues...

$(".gallary-bg").click(function() {
  $(this).addClass("animated fadeOut");
  $(this).children().children().addClass("fadeLeft");
  $(this).children().remove();
  var rmBg = $(this);
  setTimeout(() => {
    rmBg.removeClass("gallary-bg-block");
  }, 10);
});
const closemodal = img => {
  $(img).addClass("animated fadeOut");
  $(img).children().children().addClass("fadeLeft");
  $(img).children().remove();
  var rmBg = $(img);
  setTimeout(() => {
    rmBg.removeClass("gallary-bg-block");
  }, 400);
}
const openModal = img => {
  const imgClone = $(img).closest('.mw-stack__item').find('input[type="radio"]').attr('data-image');
  // console.log(imgClone);
  $(".gallary-bg").addClass("gallary-bg-block")
  // $(".gallary-bg").html('<div class="img_center"><img src="' + imgClone + '" /></div>');
  $(".gallary-bg img").attr('onclick', '');
  $(".gallary-bg img").addClass("animated fadeIn");
  $(".gallary-bg").removeClass("animated fadeOut");
  $('.gallary-bg img').attr('id', 'myimage');

  // magnify("myimage", 2);
}
//  if($( window ).width() > 767){
$(document).ready(function() {
  $('.cutomizeTxt').click(function() {
    $('.mw-apo-container').toggle();
    $('.mobile_price2').toggle();
    $(this).toggleClass('active');

  })
  $('.extra_infocon').click(function() {
    //console.log('dsfsdf');
    $('.extra_info').toggle(); // This toggles the display
  });
  //$('.price-item--regular').attr('style','opacity:0');
  var countDownDate = new Date("Dec 1, 2022 15:37:25").getTime();
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  setTimeout(function() {

    $('#custom_add_to_cart_btn').click(function(e) {

      var isvalid = true;

      $('div[data-helptext-type="required"]').each(function() {

        var text = $(this).text();
        var select_val = $(this).closest('.mw-option--required').find('select').val();
        if (select_val != undefined && select_val != 'undefined') {
          if (select_val == '') {
            $('#variant_error').remove();
            $('.mw-apo-container').append('<p id="variant_error" style="color:red;">' + text + '</p>');
            isvalid = false;
            return false;
          } else {
            $('#variant_error').remove();
          }
        } else {
          if ($(this).closest('.mw-option--required').find('input[type="radio"]:checked').length < 1) {
            $('#variant_error').remove();
            $('.mw-apo-container').append('<p id="variant_error" style="color:red;">' + text + '</p>');
            isvalid = false;
            return false;
          } else {
            $('#variant_error').remove();
          }
        }
      })
    })
    //$('.mw-apo-add-to-cart-cloned').hide();
    //change_image($('.product-form input[type="radio"]')); 
  }, 5000);

  setTimeout(function() {
    //console.log('time started');
    //product-form__submit button button--full-width button--primary mw-apo-add-to-cart-cloned
    $('.mw-label').hover(function() {
      var img = $(this).find('input[type="radio"]').attr('data-image');
      //console.log('time hovered');
      setTimeout(function() {

        if (img != null && img != undefined && img != 'undefined') {
          // $('.tippy-box').attr('onclick', 'openModal(this)');
          // console.log('time openModal');
          $(".gallary-bg").html('<div class="img_center"><img src="' + img + '" /></div>');
        }
      }, 200);
    })
    setTimeout(function() {
      $('.chair_summary').each(function() {
        $(this).find('h4').addClass('tab1');
        $(this).find('ul').addClass('tabcontent');
        $(this).find('ul').hide();
      })
      $('.tab').click(function() {

        if ($(this).hasClass('active')) {
          if ($(this).attr('data-id') == 'o_520080') {
            $('#o_520087').hide();
          }
          if ($(this).attr('data-id') == 'o_2172876') {
            $('#o_2172877').hide();
            $('#o_520257').hide();
          }
          if ($(this).attr('data-id') == 'o_502386') {
            $('#o_525895').hide();
          }
          $('.tabcontent').hide(400);
          $('.tab').removeClass('active');

        } else {
          // Anthros Metrics 
          if ($(this).attr('data-id') == 'o_520080') {
            $('#o_520087').show();
          } else if ($(this).attr('data-id') != undefined) {
            $('#o_520087').hide();
          }
          // Casters 
          if ($(this).attr('data-id') == 'o_2172876') {
            $('#o_2172877').show();
            $('#o_520257').show();
            $('#o_638388').show();
          } else if ($(this).attr('data-id') != undefined) {
            $('#o_2172877').hide();
            // $('#o_520257').hide();
            // $('#o_638388').hide();
          }
          // Trim Options
          if ($(this).attr('data-id') == 'o_502386') {
            $('#o_525895').show();

          } else if ($(this).attr('data-id') != undefined) {
            $('#o_525895').hide();
          }

          if ($(this).attr('data-id') == 'o_638387') {
            //$('#o_638388').toggle();

          } else if ($(this).attr('data-id') != undefined) {
            // $('#o_638388').hide();
          }

          $('.tabcontent').hide();
          $(this).closest('.chair_summary').find('.tabcontent').first().show(400);
          $('.tab').removeClass('active');
          $(this).toggleClass('active');
        }
        if ($(window).width() < 993) {
          $("html, body").animate({
            scrollTop: $(this).offset().top - 435
          }, 300);
        }
      })
    }, 2000);
    // cHANGE IMAGE FUNCTION
    function numberWithCommas(number) {
      var parts = number.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }

    function change_image(et) {
      var rules = localStorage.getItem('rules');
      var variant_name = $(et).attr('name');
      var isvalid = true;

      $('div[data-helptext-type="required"]').each(function() {

        var text = $(this).text();
        var select_val = $(this).closest('.mw-option--required').find('select').val();
        if (select_val != undefined && select_val != 'undefined') {
          if (select_val == '') {

            isvalid = false;
            // return false;
          } else {
            $('#variant_error').remove();
          }
        } else {
          if ($(this).closest('.mw-option--required').find('input[type="radio"]:checked').length < 1) {

            isvalid = false;
            // return false;
          } else {
            $('#variant_error').remove();
          }
        }

      })

      if (isvalid == true) {

        $('#custom_add_to_cart_btn').hide();
        $('.mw-apo-add-to-cart-cloned').show();
      } else {
        //  $('#custom_add_to_cart_btn').show();
        //  $('.mw-apo-add-to-cart-cloned').hide();
        $('#custom_add_to_cart_btn').hide();
        $('.mw-apo-add-to-cart-cloned').show();
      }
      var image_name = '';

      var pr_price = $('#product_price').val();
      pr_price = parseFloat(pr_price);

      var variant_price = 0;
      $('.product-form input[type="radio"]:checked').each(function() {

        variant_price = variant_price + parseFloat($(this).attr('data-price'));
      })
      $('.product-form select option:selected').each(function() {
        var prc = $(this).attr('data-price');
        if (prc != undefined && prc != 'undefined' && prc != null && prc != '') {
          variant_price = variant_price + parseFloat($(this).attr('data-price'));
        }
      })
      var total_price = pr_price + variant_price;
      //$('#product_price').val(total_price)
      if (!isNaN(total_price)) {
        var extra_price = total_price + 395
        $('.extra_price').text('$' + numberWithCommas(extra_price.toFixed(2)));
        $('.price-item--regular').text('$' + numberWithCommas(total_price.toFixed(2)) + '');
        //$('.price-item--regular').attr('style','opacity:1');
      }
      $('.klarna_price').text('$' + (total_price / 4).toFixed(2));
      variant_price = parseFloat(variant_price);

      $.each(JSON.parse(rules), function(index, value) {
        var is_true = true;
        var str1 = value.rule.title;
        if (value.rule.title != '' && str1.indexOf('{index}') != -1) {
          $.each(value.rule.conditions, function(ind, val) {
            var option_val = $('input[name="mw_opts[' + val.option_id + ']"]:checked').val();

            if (option_val == 'v_502382_l6dixwf8') {
              $('.4-stroke-soft').show();
            } else if (option_val == 'v_2883688') {
              $('.4-stroke-soft').hide();
            }
            //if(val.values[0] != option_val){
            if ($.inArray(option_val, val.values) == -1) {
              is_true = false;
            }
          })
        } else {
          is_true = false;
        }
        if (is_true == true) {

          return value.rule.title;

          // return false;
        }

      })
    }
    setTimeout(function() {

      $('.product-form input[type="radio"], .product-form select').each(function() {

        var name = change_image($(this));

      })
      $('.product-form input[type="radio"]:checked').each(function() {
        let title_name = $(this).closest('div').find('.title_name').text();
        if ($(this).val() == 'v_19917906') {
          title_name += '<del>$199</del>'
        }
        let title_format = title_name.split('+');
        let bold_title = '';
        if (title_format[1] != undefined) {
          bold_title = '+' + title_format[1];
        }
        $(this).closest('.chair_summary').find('.new_title_name').remove();
        $(this).closest('.chair_summary').find('h4').append('<span class="new_title_name">' + title_format[0] + '<b>' + bold_title + '</b>' + '</span>');
        $(this).closest('.mw-option__container').find('.mw-option__value').removeClass('radio_active');
        $(this).closest('.mw-option__value').addClass('radio_active');

      })
      $('.product-form input[type="radio"]').change(function() {
        let title_name = $(this).closest('div').find('.title_name').text();
        if ($(this).val() == 'v_19917906') {
          title_name += '<del>$199</del>'
        }
        let title_format = title_name.split('+');
        let bold_title = '';
        if (title_format[1] != undefined) {
          bold_title = '+' + title_format[1];
        }
        $(this).closest('.chair_summary').find('.new_title_name').remove();
        $(this).closest('.chair_summary').find('h4').append('<span class="new_title_name">' + title_format[0] + '<b>' + bold_title + '</b>' + '</span>');
        $(this).closest('.mw-option__container').find('.mw-option__value').removeClass('radio_active');
        $(this).closest('.mw-option__value').addClass('radio_active');

      })
      $('.product-form input[type="radio"], .product-form select').change(function() {
        var valchecked = $(this).val();
        //console.log('.fixed_select_option='+valchecked);
        console.log('is_checked=' + $(this).is(":checked"));

        var img_click = $(this).attr('data-image');
        //$(this).closest('.mw-option').find('.fixed_select_option').hide();
        if (img_click != '' && img_click != undefined && img_click != 'undefined' && img_click != null) {
          //$(this).closest('.mw-stack__item').find('.fixed_select_option').show();
          //alert('sds');
        }
        $(this).closest('.mw-option__container').find('.mw-option__value').removeClass('radio_active');
        $(this).closest('.mw-option__value').addClass('radio_active');
        if (valchecked == 'v_17990463') {
          $('#v_17990486').click();
        }
        if (valchecked == 'v_17990464') {
          $('#v_17990487').click();
        }
        if (valchecked == "v_3035424" || valchecked == "v_3035425" || valchecked == "v_520087_lhbj3vep") {
          $('.showhide_weight').show();
        } else {
          $('.showhide_weight').hide();
        }
        var name = change_image($(this));

      })
    }, 1000);

  }, 3000);
  $(window).scroll(function() {
    var sticky = $('.header-wrapper'),
      scroll = $(window).scrollTop();

    if (scroll >= 50) sticky.addClass('added_class');
    else sticky.removeClass('added_class');
  });

  var cache_hash = window.mwApoInit.cache_hash;
  var product_id = window.mwApoInit.product.id;
  var variants_id = window.mwApoInit.product.variants[0].id;
  // Desktop Start

  // Desktop End 
  // Mobile Start
  //if ($(window).width() < 993) {
  let checkExist = setInterval(function() {
    if ($('.mw-apo-container').length) {
      // setTimeout(function() {
      $.getJSON('https://apo-api.mageworx.com/front/product/anthroschair.myshopify.com/' + cache_hash + '/' + product_id + '/' + variants_id + '.js', function(jd) {
      localStorage.setItem('rules', JSON.stringify(jd.rules));
      var options = jd.options;
      var values = jd.values;

      var html = '';
      var i = 0;
      
      setTimeout(function() {
        $.each(values, function(key, val) {
          if (val.value.input_type == 'select') {
            $('select option[value="' + val.value.id + '"]').attr('data-price', val.value.pricing.price);
          }
          let new_title_black = val.value.title;

          $('#' + val.value.id).attr('data-price', val.value.pricing.price);
          $('#' + val.value.id).closest('.mw-stack__item').append('<span class="title_name">' + new_title_black.split('+$0')[0] + '</span>');
          if (val.value.id == "v_3993314" || val.value.id == "v_3993315") {
            $('#' + val.value.id).closest('.mw-stack__item').append(val.value.description);
          }

          if (val.value.images[0] != null && val.value.images[0] != undefined) {
            var hover_image = val.value.images[0]['url'];
            $('#' + val.value.id).attr('data-image', val.value.images[0]['url']);
            var disc_class = '';
            var option_description = '';
            if (val.value.description != '') {
              disc_class = 'with_description';
              option_description = '<div class="option_description">' + val.value.description + '</div>';
            }
          }
        });
        
        // ===== DEFINE AND RUN ensureChairSummaryWrappers FIRST =====
        function ensureChairSummaryWrappers() {
          $('.mw-option[data-option-id]').each(function() {
            const $option = $(this);
            const optionId = $option.attr('data-option-id');
            const optionType = $option.attr('class').match(/mw-option--type-(\w+)/)?.[1] || 'unknown';
            
            const labelSelector = optionType === 'select' 
              ? '.mw-label[for="select_' + optionId + '"]'
              : '.mw-label[for="' + optionId + '"]';
            
            const $label = $option.find(labelSelector).first();
            const $strongText = $label.find('.mw-text--style-strong').first();
            
            // Get the raw text from the strong element
            let rawTitle = $strongText.text().trim();
            
            // If .title span doesn't exist, CREATE it
            if ($strongText.find('.title').length === 0 && rawTitle) {
              // Wrap the text in .title span
              $strongText.html('<span class="title">' + rawTitle + '</span>');
            }
            
            const $titleSpan = $strongText.find('.title').first();
            
            // TITLE TEXT MAPPING - Transform APO titles to match configMenu
            const titleMap = {
              'CHAIR COLOR': 'Chair Color Options',
              'Chair Color Options': 'Chair Color Options',
              'FABRIC': 'Fabric Options', 
              'Fabric Options': 'Fabric Options',
              'BACK PANEL': 'Back Panel Options',
              'Back Panel Options': 'Back Panel Options',
              'CONTROL CAPS': 'Control Caps',
              'Control Caps': 'Control Caps',
              'BASE': 'Base Style Options',
              'Base Style Options': 'Base Style Options',
              'ARMS': 'Arm Options',
              'Arm Options': 'Arm Options',
              'FOOT SUPPORT': 'Foot Support',
              'CASTERS': 'CASTERS',
              'TILT OPTIMIZATION': 'TILT OPTIMIZATION',
              'Tilt Optimization': 'Tilt Optimization'
            };
            
            // SUBTITLE MAPPING
            const subtitleMap = {
              'Chair Color Options': 'Choose your chair color from the options below.',
              'Fabric Options': 'Choose your performance fabric from the options below.',
              'Back Panel Options': 'Choose your back panel from the options below.',
              'Control Caps': '',
              'Base Style Options': 'Choose your base style from the options below.',
              'Arm Options': 'Choose your arms from the options below.',
              'Foot Support': 'Recommended if under 5\'8" (5 Leg Base) or 5\'9" (4 Leg Base) *Keeps feet grounded while in tilt position.',
              'CASTERS': '',
              'TILT OPTIMIZATION': '<br><span class="springtxt"><strong>Standard</strong> 140 lbs to 300 lbs<br><strong>Light</strong> Under 140 lbs (tested up to 160 lbs)</span>'
            };
            
            // Replace the title text if needed
            if ($titleSpan.length) {
              const currentTitle = $titleSpan.text().trim();
              if (titleMap[currentTitle]) {
                $titleSpan.text(titleMap[currentTitle]);
              }
              
              // Add subtitle if it doesn't exist
              const finalTitle = $titleSpan.text().trim();
              if ($strongText.find('.subtxt').length === 0 && subtitleMap[finalTitle]) {
                const subtitle = subtitleMap[finalTitle];
                if (subtitle) {
                  $strongText.append('<span class="subtxt">' + subtitle + '</span>');
                }
              }
            }
            
            // Create chair_summary wrapper if needed
            if ($option.closest('.chair_summary').length === 0) {
              let optionTitle = $titleSpan.text().trim();
              if (!optionTitle) {
                optionTitle = rawTitle || optionId;
              }
              
              const $wrapper = $('<div class="chair_summary ' + optionId + '"></div>');
              const needsTitleSpan = optionType !== 'select';
              const titleSpan = needsTitleSpan ? '<span class="new_title_name"><b></b></span>' : '';
              const $h4 = $('<h4 class="tab1" data-id="' + optionId + '">' + optionTitle + titleSpan + '</h4>');
              
              $option.wrap($wrapper);
              $option.before($h4);
            }
          });
        }
        
        // Call it immediately to fix titles BEFORE Dopple listeners attach
        ensureChairSummaryWrappers();
        
        // ===== NOW dispatch optionsReady event =====
        var event = new Event("optionsReady");
        window.dispatchEvent(event);
        
        // ===== WRAPPING FUNCTIONS =====
        function wrapFabricOptions() {
          const athlonFabrics = ['IVORY', 'ONYX', 'STEEL', 'DUNE', 'PINK', 'LAVENDER'];
          
          const $athlonElements = $('.fabric-div .mw-option__value').filter(function() {
            const titleText = $(this).find('.title_name').text().trim();
            return athlonFabrics.includes(titleText);
          });
          
          if ($athlonElements.length > 0) {
            $athlonElements.wrapAll('<div class="shapeknit"/>');
          }
          
          const $portElements = $('.fabric-div .mw-option__value').filter(function() {
            const titleText = $(this).find('.title_name').text().trim();
            return titleText.includes('PORT');
          });
          
          if ($portElements.length > 0) {
            $portElements.wrapAll('<div class="port_leather"/>');
          }
        }

        function wrapBackPanelOptions() {
          const $standardBlack = $('.back-div .mw-option__value').filter(function() {
            const titleText = $(this).find('.title_name').text().trim();
            return titleText === 'ONYX' && !titleText.includes('OAK') && !titleText.includes('PORT');
          });
          
          if ($standardBlack.length > 0) {
            $standardBlack.wrapAll('<div class="standard_black"/>');
          }
          
          const woodOptions = ['NATURAL OAK', 'IVORY ASH', 'GREIGE OAK', 'WALNUT'];
          const $woodElements = $('.back-div .mw-option__value').filter(function() {
            const titleText = $(this).find('.title_name').text().trim();
            return woodOptions.some(wood => titleText.includes(wood));
          });
          
          if ($woodElements.length > 0) {
            $woodElements.wrapAll('<div class="wood_section"/>');
          }
          
          const specialtyKeywords = ['CARBON FIBER', 'CIRCUIT', 'SKELETON', 'US FLAG', 'MIAMI HERETICS'];
          const $specialtyElements = $('.back-div .mw-option__value').filter(function() {
            const titleText = $(this).find('.title_name').text().trim();
            return specialtyKeywords.some(keyword => titleText.includes(keyword));
          });
          
          if ($specialtyElements.length > 0) {
            $specialtyElements.wrapAll('<div class="specialty"/>');
          }
          
          const $bitcoinElements = $('.back-div .mw-option__value').filter(function() {
            const titleText = $(this).find('.title_name').text().trim();
            return titleText.includes('BITCOIN');
          });
          
          if ($bitcoinElements.length > 0) {
            $bitcoinElements.wrapAll('<div class="bitcoin_data"/>');
          }
        }

        function addSectionHeaders() {
          if ($('.shapeknit').length > 0 && !$('.shapeknit_text').length) {
            $('<div class="shapeknit_text"><h2>Athlon Performance Fabric</h2><p>A high performance upholstery designed to meet the demands of daily use while providing exceptional comfort and style.</p></div>').insertBefore('.shapeknit');
          }
          
          if ($('.port_leather').length > 0 && !$('.port_leather_text').length) {
            $('<div class="port_leather_text"><h2>Port Leather Alternative</h2><p>An environmentally conscious synthetic leather that is phthalate free. Wipeable for cleaning and disinfecting</p></div>').insertBefore('.port_leather');
          }
          
          if ($('.standard_black').length > 0 && !$('.standard_black_text').length) {
            $('<div class="standard_black_text"><h2>Standard Black</h2></div>').insertBefore('.standard_black');
          }
          
          if ($('.wood_section').length > 0 && !$('.wood_text').length) {
            $('<div class="wood_text"><h2 style="display: inline; margin-right: 3px;">Wood</h2><sup id="backs_infocon" style="display: inline;">&#9432;</sup><span id="backs_info" style="display: none;">Anthros real-wood back panels are produced using a high-grade White Oak, with beautiful grain spacing and coloring.</span></div>').insertBefore('.wood_section');
          }
          
          if ($('.specialty').length > 0 && !$('.specialty_text').length) {
            $('<div class="specialty_text"><h2>Specialty</h2></div>').insertBefore('.specialty');
          }
          
          $('#backs_infocon').off('click hover').click(function() {
            $('#backs_info').toggle();
          }).hover(
            function() { $('#backs_info').show(); },
            function() { $('#backs_info').hide(); }
          );
        }
        
        // ===== CALL WRAPPING FUNCTIONS AFTER A DELAY =====
        setTimeout(function() {
          wrapFabricOptions();
          wrapBackPanelOptions();
          addSectionHeaders();
        }, 500);
        
      }, 1000);

      $('.list_items .item').click(function() {
        var show_id = $(this).attr('data-id');
        $('.mw-option--type-swatch').hide();
        $('#' + show_id).show();
        $('.list_items .item').removeClass('active');
        $(this).addClass('active');
      });

    }); // END of $.getJSON - Everything above should stay

    // ===== DELETE EVERYTHING FROM HERE TO LINE 299 =====
    // This is duplicate code and will cause errors

    $('.extra_infocon').hover(
      function() {
        $('.extra_info').show();
      },
      function() {
        $('.extra_info').hide();
      }
    );

    $('.product-form input[type="radio"]').change(function() {
      let title_name = $(this).closest('div').find('.title_name').text();
      if ($(this).val() == 'v_19917906') {
        title_name += '<del>$199</del>'
      }
      $(this).closest('.chair_summary').find('.new_title_name').remove();
      $(this).closest('.chair_summary').find('h4').append('<span class="new_title_name">' + title_name + '</span>');
    });

    clearInterval(checkExist);
    }
  }, 100);
  // }
  // Mobile End
  $(document).ready(function() {
    setTimeout(function() {
      function showhide(et) {
        var show_id = $(et).attr('data-id');
        $('mw-option--type-swatch').hide();
        $('#' + show_id).show();
      }
    }, 2000);

  });

  $('.custom-product').show();

  $('#days_left').text(days);
});
// }

//DOPPLE CONTROLS FOR AR AND SNAPSHOT
let avAr // The <av-ar> tag
let arDiv // QR code container <div>
let arTriggerButton // Custom AR trigger button
let arCloseButton // Custom AR close
const doppleVisual = document.querySelector('atlatl-visual')
const doppleProduct = document.querySelector('av-product')

$('#nativeUIIconButton-av-ar').click(function() {
  $('.sticky_img').css({
    'z-index': '10000',
  });
});

$('.native-ui__modal-close-button').click(function() {
  $('.sticky_img').css({
    'z-index': '9',
  });
});
$(document).ready(function() {

  if ($(window).width() > 992) {
    var height = $(window).height();

    //console.log('avCanvas='+$('#main-container').innerHeight());
    $('.custom_product_section.product__info-wrapper').attr('style', 'max-height:' + height + 'px; overflow:scroll;');
    window.addEventListener('resize', function(event) {
      height = $(window).height();
      //console.log('resize='+height);
      $('.custom_product_section.product__info-wrapper').attr('style', 'max-height:' + height + 'px;  overflow:scroll;');

    });
  }

  checkScroll();

  $(window).scroll(function() {
    checkScroll();
  });

  function checkScroll() {
    if ($(window).width() < 992) {
      if ($(window).scrollTop() > 0) {
        $('.mobile_price').addClass('price_fixed');
        $('.cutomizeTxt').fadeOut(); // Hides the element when not at the top
        $('.review_img').fadeOut(); // Hides the element when not at the top
        $('.affirm-line').fadeOut(); // Hides the element when not at the top
        $('.mobile_display').fadeOut(); // Hides the element when not at the top
      } else {
        $('.mobile_price').removeClass('price_fixed');
        $('.cutomizeTxt').fadeIn(); // Shows the element when at the top
        $('.affirm-line').fadeIn(); // Shows the element when at the top
        $('.review_img').fadeIn(); // Shows the element when at the top
        $('.mobile_display').fadeIn(); // Shows the element when at the top
      }
    }
  }

  setInterval(function() {
    $('.option_error').remove();
    var error_html = '';
    $('.mw-stack__item .mw-option__helptext').each(function() {
      if (!$(this).hasClass('mw-hidden')) {
        error_html += '<p>' + $(this).text() + '</p>';

      }

    })
    $('<div id="option_error" class="option_error">' + error_html + '</div>').insertBefore('.affirm-line');
  }, 100);

});

function clickUntilSelected(
  sel, {
    container = '.mw-option__value',
    selectedClass = 'mw-option__value--selected',
    interval = 100,
    maxTries = 20
  } = {}
) {
  let tries = 0;
  const timer = setInterval(() => {
    const $input = $(sel);
    const $wrapper = $input.closest(container);
    // console.log('checked value', $wrapper.find('input:checked').length);
    // if wrapper isn't found or already selected, stop
    if (!$wrapper.length || $wrapper.find('input:checked').length > 0) {
      clearInterval(timer);
      return;
    }

    // if we've tried enough times, give up
    if (++tries >= maxTries) {
      clearInterval(timer);
      console.warn(`clickUntilSelected: failed to select ${sel} after ${maxTries} tries`);
      return;
    }
    console.log('input', $input)
    // otherwise, fire the click and try again later
    $input[0].click();
  }, interval);
}

// batch version
function clickIfNotSelected(selectors) {
  selectors.forEach(sel => clickUntilSelected(sel));
}
$('#show_options').click(function() {
  setTimeout(function() {
    clickIfNotSelected([
      '#v_20595456',
      '#v_20595479'
    ]);
  }, 100);
});

window.addEventListener('load', async () => {
  await doppleVisual.ready();

  // Get the current URL path
  const currentPath = window.location.pathname;

  // Set the base and 4D arms (same for both)
  doppleProduct.product.setValue('base', 'fiveSpoke');
  doppleProduct.product.setValue('4DArms', true);

  // Set fabric and backPanel based on URL
  if (currentPath === '/products/anthros-chair-configuration-one') {
    doppleProduct.product.setValue('fabric', 'heatherBlackGAFabric');
    doppleProduct.product.setValue('backPanel', 'walnut');
  } else if (currentPath === '/products/anthros-chair-configuration-two') {
    doppleProduct.product.setValue('fabric', 'ivoryGAFabric');
    doppleProduct.product.setValue('backPanel', 'naturalOak');
    doppleProduct.product.setValue('chassisColor', 'quartz');
    doppleProduct.product.setValue('controlArmCapColor', 'glossStone');
  } else if (currentPath === '/products/anthros-chair-configuration-three') {
    doppleProduct.product.setValue('fabric', 'heatherBlackGAFabric');
    doppleProduct.product.setValue('backPanel', 'circuitOnyx');
  } else if (currentPath === '/products/anthros-chair-configuration-four') {
    doppleProduct.product.setValue('fabric', 'steelGAFabric');
    doppleProduct.product.setValue('chassisColor', 'quartz');
    doppleProduct.product.setValue('controlArmCapColor', 'glossStone');
  } else if (currentPath === '/products/anthros-chair-configuration-five') {
    doppleProduct.product.setValue('fabric', 'ivoryGAFabric');
    doppleProduct.product.setValue('backPanel', 'colorFlagUSA');
  }
});

$(document).ready(function() {
  // Wait for Slick to initialize
  setTimeout(function() {
    const $sliderDots = $('.slick-dots');
    if (!$sliderDots.length) return;

    const SLIDE_DURATION = 5000; // 5 seconds
    const DOT_SIZE = 8; // Size of inactive dots
    const BAR_WIDTH = 40; // Width of active bar
    const DOT_GAP = 0; // Base gap between dots

    let currentSlide = 0;
    let animationFrame;
    let startTime;
    let isPaused = false;
    let totalSlides = 0;

    // Style the dots container
    $sliderDots.css({
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      'padding': '5px 0'
    });

    // Transform existing dots into progress bars
    function initializeDots() {
      const $dots = $sliderDots.find('li');
      totalSlides = $dots.length;

      $dots.each(function(index) {
        const $dot = $(this);
        const $button = $dot.find('button');
        const isActive = $dot.hasClass('slick-active');
        const buttonText = $button.text();

        // Style the li with base margin
        $dot.css({
          'list-style': 'none',
          'margin': '0',
          'padding': '0',
          'flex-shrink': '0',
          'margin-right': index === $dots.length - 1 ? '0' : `${DOT_GAP}px`,
          'transition': 'margin-right 0.3s ease'
        });

        // Create new structure
        $button.html(`
          <span class="sr-only">${buttonText}</span>
          <span class="progress-container" style="
            position: relative;
            display: block;
            height: ${DOT_SIZE}px;
            overflow: hidden;
            border-radius: ${DOT_SIZE}px;
            background-color: rgba(200, 200, 200, 0.4);
            width: ${isActive ? BAR_WIDTH : DOT_SIZE}px;
            transition: width 0.3s ease;
          ">
            <span class="progress-fill" style="
              position: absolute;
              top: 0;
              left: 0;
              display: block;
              height: 100%;
              width: 100%;
              border-radius: ${DOT_SIZE}px;
              background-color: rgb(100, 100, 100);
              transform: scaleX(0);
              transform-origin: left center;
            "></span>
          </span>
        `);

        // Style the button
        $button.css({
          'padding': '0',
          'margin': '0',
          'border': 'none',
          'background': 'transparent',
          'cursor': 'pointer',
          'display': 'block'
        });
      });
    }

    // Animate the active progress bar
    function animateProgress(timestamp) {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / SLIDE_DURATION, 1);

      const $activeDot = $sliderDots.find('li').eq(currentSlide);
      const $progressFill = $activeDot.find('.progress-fill');

      // Animate scale from 0 to 1
      $progressFill.css('transform', `scaleX(${progress})`);

      // Check if animation is complete
      if (progress >= 1) {
        if (currentSlide < totalSlides - 1) {
          // Move to next slide
          const $nextButton = $sliderDots.find('li').eq(currentSlide + 1).find('button');
          $nextButton.trigger('click');
          startTime = timestamp;
          animationFrame = requestAnimationFrame(animateProgress);
        }
      } else {
        animationFrame = requestAnimationFrame(animateProgress);
      }
    }

    // Update visual state when slide changes
    function updateActiveState(newIndex) {
      const $dots = $sliderDots.find('li');
      const extraMargin = BAR_WIDTH - DOT_SIZE; // How much extra space the bar needs

      $dots.each(function(index) {
        const $dot = $(this);
        const $container = $dot.find('.progress-container');
        const $progressFill = $dot.find('.progress-fill');

        // Reset all margins to base first
        if (index === $dots.length - 1) {
          $dot.css('margin-right', '0');
        } else if (index === newIndex) {
          // Active dot gets extra margin to make room for the bar
          $dot.css('margin-right', `${DOT_GAP + extraMargin}px`);
        } else {
          // All other dots keep normal spacing
          $dot.css('margin-right', `${DOT_GAP}px`);
        }

        if (index === newIndex) {
          // Active slide - expand to bar and reset progress
          $container.css('width', `${BAR_WIDTH}px`);
          $progressFill.css('transform', 'scaleX(0)');
        } else if (index < newIndex) {
          // Completed slides - show as filled dot
          $container.css('width', `${DOT_SIZE}px`);
          $progressFill.css('transform', 'scaleX(1)');
        } else {
          // Future slides - show as empty dot
          $container.css('width', `${DOT_SIZE}px`);
          $progressFill.css('transform', 'scaleX(0)');
        }
      });

      currentSlide = newIndex;
      startTime = null;

      // Start animation if not on last slide and not paused
      if (currentSlide < totalSlides - 1 && !isPaused) {
        cancelAnimationFrame(animationFrame);
        animationFrame = requestAnimationFrame(animateProgress);
      }
    }

    // Listen for Slick slide changes
    const $slider = $('.slick-slider');
    if ($slider.length) {
      $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        updateActiveState(nextSlide);
      });
    }

    // Handle manual dot clicks
    $sliderDots.on('click', 'button', function() {
      const $clickedLi = $(this).closest('li');
      const $allLis = $sliderDots.find('li');
      const clickedIndex = $allLis.index($clickedLi);

      if (clickedIndex !== -1 && clickedIndex !== currentSlide) {
        updateActiveState(clickedIndex);
      }
    });

    // Optional: Pause on hover
    $sliderDots.on('mouseenter', function() {
      isPaused = true;
      cancelAnimationFrame(animationFrame);
    });

    $sliderDots.on('mouseleave', function() {
      isPaused = false;
      if (currentSlide < totalSlides - 1) {
        startTime = null;
        animationFrame = requestAnimationFrame(animateProgress);
      }
    });

    // Initialize everything
    initializeDots();
    updateActiveState(0);

    // Start the animation
    if (totalSlides > 1) {
      animationFrame = requestAnimationFrame(animateProgress);
    }

  }, 1000);
});

// Function to get the selected value's title from an option group by searching for title text
function getSelectedTitleByText(titleText) {
  // Find all .mw-option elements
  const allOptions = document.querySelectorAll('.mw-option[data-option-id]');
  
  // Find the one whose .title span matches our search text
  for (let option of allOptions) {
    const titleSpan = option.querySelector('.mw-text--style-strong .title');
    if (titleSpan && titleSpan.textContent.trim() === titleText) {
      // Found the right option group, now get the selected value
      let selectedValue = option.querySelector('.mw-option__value.radio_active');
      
      if (!selectedValue) {
        const selectedInput = option.querySelector('input[type="radio"]:checked');
        if (selectedInput) {
          selectedValue = selectedInput.closest('.mw-option__value');
        }
      }
      
      if (selectedValue) {
        const titleElement = selectedValue.querySelector('.title_name');
        return titleElement ? titleElement.textContent.trim() : null;
      }
    }
  }
  
  return null;
}

// Function to update the configuration card
function updateConfigCard() {
  console.log('Updating config card...');

  const configDetails = document.querySelector('.config-details .config-text');
  if (!configDetails) {
    console.warn('Config details not found');
    return;
  }

  const paragraphs = configDetails.querySelectorAll('p');
  if (paragraphs.length < 3) {
    console.warn('Not enough paragraphs found:', paragraphs.length);
    return;
  }

  // Get selected values by searching for title text (no IDs needed!)
  const chairColor = getSelectedTitleByText('Chair Color Options');
  const fabricOption = getSelectedTitleByText('Fabric Options');
  const backPanel = getSelectedTitleByText('Back Panel Options');

  console.log('Selected values:', {
    chairColor,
    fabricOption,
    backPanel
  });

  if (chairColor) {
    paragraphs[0].innerHTML = `<strong>Color:</strong> ${chairColor}`;
  }

  if (fabricOption) {
    paragraphs[1].innerHTML = `<strong>Fabric:</strong> ${fabricOption}`;
  }

  if (backPanel) {
    paragraphs[2].innerHTML = `<strong>Back:</strong> ${backPanel}`;
  }
}

// Add event listeners to all radio inputs in the three option groups
function attachListeners() {
  console.log('Attaching listeners...');
  const titleTexts = ['Chair Color Options', 'Fabric Options', 'Back Panel Options'];
  let listenersAttached = false;

  // Find all .mw-option elements
  const allOptions = document.querySelectorAll('.mw-option[data-option-id]');
  
  allOptions.forEach(option => {
    const titleSpan = option.querySelector('.mw-text--style-strong .title');
    if (titleSpan && titleTexts.includes(titleSpan.textContent.trim())) {
      const labels = option.querySelectorAll('.mw-option__value label');
      labels.forEach(label => {
        label.addEventListener('click', () => {
          console.log('Option clicked in:', titleSpan.textContent.trim());
          // Use setTimeout to wait for the radio_active class to update
          setTimeout(updateConfigCard, 150);
        });
      });
      console.log(`Added ${labels.length} listeners for ${titleSpan.textContent.trim()}`);
      listenersAttached = true;
    }
  });

  return listenersAttached;
}

// Wait for the option groups to appear in the DOM
function waitForOptions() {
  console.log('Waiting for option groups to load...');

  // Try to attach listeners immediately
  if (attachListeners()) {
    console.log('Options found and listeners attached');
    return;
  }

  // If options aren't ready, use MutationObserver to watch for them
  const observer = new MutationObserver((mutations) => {
    // Check if any of our option groups now exist by looking for .title spans
    const allOptions = document.querySelectorAll('.mw-option[data-option-id]');
    const titleTexts = ['Chair Color Options', 'Fabric Options', 'Back Panel Options'];
    
    let foundAny = false;
    allOptions.forEach(option => {
      const titleSpan = option.querySelector('.mw-text--style-strong .title');
      if (titleSpan && titleTexts.includes(titleSpan.textContent.trim())) {
        foundAny = true;
      }
    });

    if (foundAny) {
      console.log('Option groups detected, attaching listeners');
      if (attachListeners()) {
        observer.disconnect();
      }
    }
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also set a timeout to try again after a delay
  setTimeout(() => {
    if (attachListeners()) {
      observer.disconnect();
    }
  }, 1000);
}

// Wait for doppleVisual to be ready before initializing
async function init() {
  console.log('Initializing config card updater...');

  if (typeof doppleVisual !== 'undefined' && doppleVisual.ready) {
    await doppleVisual.ready;
    console.log('doppleVisual ready');

    // Wait a bit more for the options to render
    setTimeout(waitForOptions, 500);
  } else {
    console.log('doppleVisual not available, using fallback');
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(waitForOptions, 500);
      });
    } else {
      setTimeout(waitForOptions, 500);
    }
  }
}

// Start initialization
init();